module.exports = __webpack_public_path__ + "static/media/ysjp3@2x.5a3d04cc.png";